<template>
    <div class="container remove-padding-margin">
        <div class="header-top bg-white ">
            <nav class="nav-center w-limit">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3" style="padding: 0px;">
                        <img class="remove-padding-margin" @click="back" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <p style="margin:0;">Login</p>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                    </div>
                </div>
            </nav>
            <div class="nav nav-tabs custom w-limit" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-wa" role="tab"
                   aria-controls="nav-home" aria-selected="true">Nomor WA</a>
                <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-email" role="tab"
                   aria-controls="nav-profile" aria-selected="false">Email</a>
            </div>
        </div>
        <main class="add-padding-default w-limit">
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-wa" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="flex-100">
                        <div class="flex-1">
                            <div class="text-outlet remove-margin mt-120">
                                <div class="color-33333 text-login-email"><span @click="silahkan">Silahkan</span> masukkan <b>nomor WhatsApp</b> Anda,
                                    Kami akan
                                    mengirimkan kode OTP untuk <b>verifikasi</b></div>
                            </div>
                            <form class="remove-padding" action="">
                                <label for="inputNomor" class="text-login-wa">Nomor Whatsapp</label>
                                <div class="input-group remove-padding mod">
                                    <div class="input-group-prepend">
                                       <vue-country-code
                                                @onSelect="onSelect"
                                                :preferredCountries="['id', 'my', 'bn']">
                                        </vue-country-code>

                                    </div>
                                    <input type="tel" class="form-control inputs" id="inputNomor"
                                           placeholder="81757875431"
                                           v-on:keyup="nomorWaOnkeyup" v-on:keydown="nomorWaOnkeyup" v-model="telp">
                                </div>
	                            <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.telp"></ErrorMessage>
                                <div class="g-recaptcha" data-sitekey="6LfTKboZAAAAAMj4Fsz2SK5_AAH-SeEBm7zT6qx0"></div>
                            </form>
                        </div>
                        <div class="text-center footer mar-bottom-20s">
                            <small class="powered">Belum punya akun ?<a @click="goregist" style="color: #007bff"><u>
                                Daftar
                                Smartlink</u></a></small>
                        </div>
                        <div class="text-center footer mar-bottom-20">
                            <small class="powered">Atau mengalami kesulitan ?<a @click="gocontact" style="color: #007bff"><br/><u>
                                Hubungi CS Kami</u> </a> atau Telp ke (0341) 5082494</small>
                        </div>
                        <div class="button-lanjut">
                            <vue-recaptcha
                                    ref="recaptcha"
                                    @verify="onCaptchaVerified"
                                    @expired="onCaptchaExpired"
                                    size="invisible"
                                    sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
                            </vue-recaptcha>
                            <button class="btn btn-login btn-long remove-margin" id="buttonSendOtp"
                                    @click="submit">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      v-if="isClicked === true"></span>
                                <span id="textBtn1">Lanjut</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-email" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <form action="blank" class="flex-100">
                        <div class="flex-1">
                            <div class="text-outlet remove-margin mt-120">
                                <div class="color-33333 text-login-email">Silahkan masukkan <b>email</b> dan <b>kata
                                    sandi</b> Anda untuk login
                                </div>
                            </div>
                            <div class="remove-padding">
                                <div class="form-group mar-bot-12">
                                    <label for="input-2" class="label-email">Email</label>
                                    <input class="form-control" type="email" v-on:keyup="cekValidate" v-model="email"
                                           id="input-2" placeholder="email@email.com"/>
	                                <ErrorMessage class="error" label="Email" :validation="$v.email"></ErrorMessage>
                                </div>

                                <div class="form-group mar-bot-12">
                                    <label for="password-field" class="label-password">Password</label>
                                    <input class="form-control" type="password" style="padding-right: 50px"
                                           v-on:keyup="cekValidate"
                                           @keyup="listenCapslock($event, 'password-field')"
                                           v-model="password" id="password-field" placeholder="Kata Sandi"/>
                                    <span toggle="#password-field" v-on:click="changeViewPass"
                                          class="fa fa-eye field-icon toggle-password"></span>
	                                <ErrorMessage class="error" label="Password" :validation="$v.password"></ErrorMessage>
                                </div>
                            </div>
                            <small>
                                <a @click="goforgot" style="color: #206CFF;">Lupa Kata Sandi?</a>
                            </small>
                        </div>
                        <div class="text-center footer mar-bottom-20">
                            <small class="powered">Belum punya akun ?<a @click="goregist" style="color: #007bff"><u>Daftar
                                Smartlink</u></a></small>
                        </div>
                        <div class="button-lanjut">
                            <button class="btn btn-login btn-long remove-margin" id="btnLoginEmail"
                                    @click="LoginEmail">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      v-if="isClicked === true"></span>
                                <span id="textBtn2">Lanjut</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import VueRecaptcha from 'vue-recaptcha';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, maxLength, email, required} from "vuelidate/lib/validators";
    
    export default {
        name: 'Login',
        components: {
            'vue-recaptcha': VueRecaptcha,
	        ErrorMessage
        },
        mounted() {
            // $('#close').hide()
            localStorage.setItem("forced", false);

            if ("telp" in localStorage) {
                var nomorTelp = localStorage.getItem("telp");
                var charLenght = nomorTelp.length;
                if (charLenght > 0) {
                    var codeCountry = nomorTelp.substring(0, 2);
                    if (codeCountry == this.telpCode) {
                        var realPhone = nomorTelp.substring(2, charLenght);
                        this.telp = realPhone;
                        $('#inputNomor').focus();
                        $('#buttonSendOtp').prop('disabled', false);
                    }
                }
            }
            if ("telp" in localStorage) {
                if ("token" in localStorage) {
                    this.$router.push('/dashboard')
                }
            }

            //initialisasi external script
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
            document.head.appendChild(recaptchaScript)

	        $('body').on('DOMSubtreeModified', '.grecaptcha-badge', function(){
		        $(".grecaptcha-badge").hide()
	        });
            
            this.checkUrlHash()
        },
        data() {
            return {
                telp: "",
                password: "",
                email: "",
                isClicked: false,
                timeoutOtp: null,
                telpCode:"62"
            }
        },
	    validations: {
		    telp: {
		    	required,
			    minLength: minLength(8),
			    maxLength: maxLength(12),
		    },
		    email: {
		    	required,
			    email,
		    },
		    password: {
		    	required,
			    minLength: minLength(6),
		    }
	    },
        methods: {
            onSelect({name, iso2, dialCode}) {
                this.telpCode=dialCode
            },
        	errorValidation(type) {
        		if (type === "wa") {
			        this.$v.telp.$touch()
        			if (this.$v.telp.$invalid) {
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        				return true
			        }
		        } else if (type === "email") {
        			if (this.$v.email.$invalid || this.$v.password.$invalid) {
				        this.$v.email.$touch();
				        this.$v.password.$touch();
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        				return true
			        }
		        }
        		return false
	        },
            silahkan(){
                var telpStr = this.telp
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");
                localStorage.setItem("telp", this.telpCode + fixTelp);
                localStorage.setItem("forced", true);
                this.$router.push('/verifikasi');

            },
            submit() {
        		if (this.errorValidation("wa")) {
        			return
		        }
                this.$refs.recaptcha.execute();
            },
            onCaptchaVerified: function (recaptchaToken) {
                this.getOTP(recaptchaToken)
                const self = this;
                self.$refs.recaptcha.reset();
            },
            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            changeViewPass(event) {
                if ($('#password-field').attr("type") == "password") {
                    $('.toggle-password').removeClass('fa fa-eye');
                    $('.toggle-password').addClass('fa fa-eye fa-eye-slash');
                    $('#password-field').attr("type", "text");
                } else {
                    $('.toggle-password').removeClass('fa fa-eye fa-eye-slash');
                    $('.toggle-password').addClass('fa fa-eye');
                    $('#password-field').attr("type", "password");
                }
            },
            cekValidate() {
            	return
                var emailData = this.email;
                var passData = this.password;
                var lenPass = passData.length;
                if (this.validateEmail(emailData) && lenPass >= 6) {
                    $('#btnLoginEmail').prop('disabled', false);
                } else {
                    $('#btnLoginEmail').prop('disabled', true);
                }
            },
            validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 13);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 13);
                var thrdcar = phoneField.substring(0, 12);
                var output
                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number = output.replace(/[^0-9]+/, '');
                var charLenght = number.length;
	            this.telp = number;
                if (charLenght >= 8 && charLenght <= 12) {
                    // $('#buttonSendOtp').prop('disabled', false);
                } else {
                    // $('#buttonSendOtp').prop('disabled', true);
                }
            },
            back() {
                this.$router.push('/startscreen')
            },
            goregist() {
                this.$router.push('/register')
            },
            gocontact() {
                window.open("https://wa.me/6285234494494", '_blank');
            },
            goforgot() {
                this.$router.push('/forgotpassword/0')
            },
            async getOTP(recaptchaToken) {
                $('#buttonSendOtp').prop('disabled', true);
                this.isClicked = true;
                $('#textBtn1').hide();
                var telpStr = this.telp
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");

	            var checkZero = fixTelp.substring(0, 1);
	            if (checkZero === "0") {
		            fixTelp = fixTelp.substring(1);
	            }

                try {
                    const dataOtp = new FormData;
                    dataOtp.append('telp', this.telpCode + fixTelp);
                    dataOtp.append('token_captcha', recaptchaToken);
                    dataOtp.append('tipe', 'login')
                    const res = await this.$axios.post(this.$baseurl + '/auth/send_otp_with_captcha', dataOtp)
                    if (res.status === 200) {
                        if (res.data.status === false) {
	                        this.$toast.error(res.data.msg)

                            this.isClicked = false
                            $('#textBtn1').show();
                            $('#buttonSendOtp').prop('disabled', false);
                        } else {
                            localStorage.setItem("telp", this.telpCode + fixTelp);
                            this.$router.push('/verifikasi');
                        }
                    }
                } catch (e) {
	                this.$catch_error_response(e)
	                this.isClicked = false
	                $('#textBtn1').show();
	                $('#buttonSendOtp').prop('disabled', false);
                }
            },
            async LoginEmail() {
        		if (this.errorValidation("email")) {
        			return
		        }
                this.isClicked = true;
                $('#textBtn2').hide();
                $('#btnLoginEmail').prop('disabled', true);
                var emailData = this.email;
                var passwordData = this.password;
                try {
                    const dataUser = new FormData;
                    const appUserAgent = navigator.userAgent
                    dataUser.append('user_agent', appUserAgent);
                    dataUser.append('email', emailData);
                    dataUser.append('password', passwordData);
                    const res = await this.$axios.post(this.$baseurl + '/auth/byemailsign', dataUser)
                    if (res.data.status === false) {
                    	this.$toast.error(res.data.msg)
                    	
	                    this.isClicked = false
	                    $('#textBtn2').show();
	                    $('#btnLoginEmail').prop('disabled', false);
                    } else {
                        localStorage.setItem("email", emailData);
                        localStorage.setItem("token", res.data.data.token);
                        localStorage.setItem("idowner", res.data.data.idowner);
                        this.$router.push('/successlogin');
                    }
                } catch (e) {
	                this.$catch_error_response(e)

	                this.isClicked = false
	                $('#textBtn2').show();
	                $('#btnLoginEmail').prop('disabled', false);
                }
            },
	        checkUrlHash() {
            	var hash = window.location.hash
            	if (hash === '#nav-email') {
            		$("#nav-profile-tab").click()
	            }
	        }
        }
    }
</script>
<style scoped>
    .mt-120 {
        margin-top: 110px;
    }

    .text-outlet.remove-margin {
        margin-bottom: 20px;
    }

    .alert-danger {
        margin: 50px auto !important;
    }

    .row.align-items-center.set-row {
        box-shadow: none !important;
    }

    .label-email {
        margin-bottom: 4px;
        color: rgba(0, 0, 0, 0.65);
    }

    .label-password {
        margin-bottom: 4px;
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.65);
    }

    .text-login-email {
        line-height: 140%;
        letter-spacing: -0.02em;
    }

    .text-login-wa {
        line-height: 21px;
        margin-bottom: 4px;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: -0.02em;
    }
</style>